import {
  Activity,
  Archive,
  Codesandbox,
  Cpu,
  Eye,
  Figma,
  GitCommit,
  Mail,
  Share2,
  Sliders,
  User,
  Users,
} from "react-feather";
import { lazy } from "react";

const routesConfig = [
  {
    component: lazy(() => import("./pages/Dashboard")),
    icon: Sliders,
    label: "Dashboard",
    path: "/dashboard",
    isAdmin: false,
    visibleInMenu: true,
    color: '#000',
  },

  {
    component: lazy(() => import("./pages/Downloads")),
    icon: Figma,
    label: "Downloads",
    path: "/suporte",
    isAdmin: false,
    visibleInMenu: true,
    color: '#000',
  },

  {
    component: lazy(() => import("./pages/pessoa/PessoaSearch")),
    icon: Users,
    label: "Clientes",
    path: "/pessoa-list",
    pathcrud: "/pessoa-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/pessoa/PessoaForm")),
    path: "/pessoa-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/pessoa/PessoaForm")),
    path: "/pessoa-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },

  {
    component: lazy(() => import("./pages/licenca/LicencaSearch")),
    icon: Activity,
    label: "Licenças",
    path: "/licenca-list",
    pathcrud: "/licenca-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/licenca/LicencaForm")),
    path: "/licenca-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/licenca/LicencaForm")),
    path: "/licenca-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },

  {
    component: lazy(() => import("./pages/pessoaContato/PessoaContatoSearch")),
    icon: Mail,
    label: "Contatos feitos",
    path: "/pessoa-contato-list",
    pathcrud: "/pessoa-contato-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/pessoaContato/PessoaContatoForm")),
    path: "/pessoa-contato-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/pessoaContato/PessoaContatoForm")),
    path: "/pessoa-contato-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },

  {
    component: lazy(() => import("./pages/user/UserSearch")),
    icon: User,
    label: "Usuários",
    path: "/user-list",
    pathcrud: "/user-form",
    isAdmin: false,
    visibleInMenu: true,
    color: '#000',
  },
  {
    component: lazy(() => import("./pages/user/UserForm")),
    path: "/user-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/user/UserForm")),
    path: "/user-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },

  {
    component: lazy(() => import("./pages/sistema/SistemaSearch")),
    icon: Codesandbox,
    label: "Sistema",
    path: "/sistema-list",
    pathcrud: "/sistema-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/sistema/SistemaForm")),
    path: "/sistema-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/sistema/SistemaForm")),
    path: "/sistema-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },

  {
    component: lazy(() => import("./pages/motivoContato/MotivoContatoSearch")),
    icon: GitCommit,
    label: "Motivo de Contato",
    path: "/motivo-contato-list",
    pathcrud: "/motivo-contato-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/motivoContato/MotivoContatoForm")),
    path: "/motivo-contato-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/motivoContato/MotivoContatoForm")),
    path: "/motivo-contato-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },  





  {
    component: lazy(() => import("./pages/pessoaAcesso/PessoaAcessoSearch")),
    icon: Share2,
    label: "Acessos de Sistema",
    path: "/pessoa-acesso-list",
    pathcrud: "/pessoa-acesso-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/pessoaAcesso/PessoaAcessoForm")),
    path: "/pessoa-acesso-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/pessoaAcesso/PessoaAcessoForm")),
    path: "/pessoa-acesso-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },

  {
    component: lazy(() => import("./pages/pessoaMaquina/PessoaMaquinaSearch")),
    icon: Cpu,
    label: "Maquinas de Cliente",
    path: "/pessoa-maquina-list",
    pathcrud: "/pessoa-maquina-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/pessoaMaquina/PessoaMaquinaForm")),
    path: "/pessoa-maquina-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/pessoaMaquina/PessoaMaquinaForm")),
    path: "/pessoa-maquina-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },


  {
    component: lazy(() => import("./pages/pessoaMovimentacao/PessoaMovimentacaoSearch")),
    icon: Eye,
    label: "Movimentações Licença",
    path: "/pessoamovimentacao-list",
    pathcrud: "/pessoamovimentacao-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/pessoaMovimentacao/PessoaMovimentacaoForm")),
    path: "/pessoamovimentacao-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/pessoaMovimentacao/PessoaMovimentacaoForm")),
    path: "/pessoamovimentacao-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },

  {
    component: lazy(() => import("./pages/SQLEditorPage")),
    icon: Eye,
    label: "Editor SQL",
    path: "/editor-sql",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },


  {
    component: lazy(() => import("./pages/personAddress/PersonAddressSearch")),
    icon: Archive,
    label: "PersonAddress",
    path: "/person-address-list",
    pathcrud: "/person-address-form",
    isAdmin: false,
    visibleInMenu: true,
    color: "#000"
  },
  {
    component: lazy(() => import("./pages/personAddress/PersonAddressForm")),
    path: "/person-address-form",
    isAdmin: false,
    visibleInMenu: false,
  },
  {
    component: lazy(() => import("./pages/personAddress/PersonAddressForm")),
    path: "/person-address-form/:id",
    isAdmin: false,
    visibleInMenu: false,
  },


];

export default routesConfig;
